module.exports = __webpack_public_path__ + "media/images/suppliers/zetacorporation-b63418ca58fa032c531fbe8ea0e65d38.png";